import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./CalendarPage.module.scss";
import { GET_RESERVATIONS_DATA_REQUEST } from "../../../redux/actions";
import { FullPageContainer } from "../../common/FullPageContainer/FullPageContainer";
import { BigCalendar } from "./components/BigCalendar/BigCalendar";
import SmallCalendar from "./components/SmallCalendar/SmallCalendar";
import { UpcomingReservations } from "./components/UpcomingReservations/UpcomingReservations";
import {
  previousReservationsSelector,
  upcomingReservationsSelector,
} from "../../../redux/selectors/reservationsData";
import { isMobileModeSelector } from "../../../redux/selectors/appStatusSelector";
import { Typography } from "../../../shared/ui/typography";
import { clsx } from "clsx";
import { IListing } from "@/views/interfaces";
import { SelectOnePropertyModal } from "./components/SelectOnePropertyModal/SelectOnePropertyModal";
import { getSelectedListingsSelector } from "@/redux/selectors/performancePageSelector";
import { CalendarProvider } from "./components/Calendar/CalendarContext";

export const CalendarPage = () => {
  const dispatch = useDispatch();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const listings: IListing[] = useSelector(getSelectedListingsSelector);
  const previousReserv: any = useSelector(previousReservationsSelector);
  const upcomingReserv: any = useSelector(upcomingReservationsSelector);
  const reservationsData = { ...previousReserv, ...upcomingReserv };

  const isMobileView = useSelector(isMobileModeSelector);
  const handleModalClose = () => setIsModalOpened(false);

  const properties = useMemo(() => {
    return (listings !== null ? listings : []).map(
      (listing) => listing.property_id
    );
  }, [listings]);

  useEffect(() => {
    if (properties.length > 1) return setIsModalOpened(true);
    dispatch({
      type: GET_RESERVATIONS_DATA_REQUEST,
      payload: properties,
    });
  }, [dispatch, properties]);

  return (
    <FullPageContainer>
      <Typography
        variant="display-md"
        weight="semibold"
        className={clsx(classes.gray900, classes.pageTitle)}
      >
        Calendar
      </Typography>
      <CalendarProvider>
      <div className={classes.calendarContainer}>
        {!isMobileView && (
          <div className={classes.column}>
            <SmallCalendar reservationsData={reservationsData} />
            <UpcomingReservations />
          </div>
        )}
        <BigCalendar reservationsData={reservationsData} />
        {isMobileView && <UpcomingReservations />}
      </div>
      </CalendarProvider>
      {isModalOpened && (
        <SelectOnePropertyModal
          open={isModalOpened}
          handleClose={handleModalClose}
        />
      )}
    </FullPageContainer>
  );
};
